import { colors } from 'ui/theme';
import { sumObjectListByKey } from 'utils/arrayHelpers';
import { localize } from 'utils/numberHelpers';
import { HelpTooltip } from 'ui/tooltip';

import { useEventSelectionContext } from '../contexts/selection';
import {
  TotalCountContainer,
  StyledTotalCountBox,
  TotalCountLabel,
  CenterAlignedTooltipText,
} from './styled';

export const TotalEventCountBox = () => {
  const { selected } = useEventSelectionContext();
  const total = sumObjectListByKey(selected, 'count');

  const tooltipContent = 'The total number of captured events (based on filter selections)';
  return (
    <TotalCountContainer data-test="total-count-container">
      <StyledTotalCountBox>
        <TotalCountLabel>
          <span>Total event count</span>
          <HelpTooltip
            iconProps={{ height: 16, width: 16, color: colors.grey25 }}
            tooltipContent={<CenterAlignedTooltipText>{tooltipContent}</CenterAlignedTooltipText>}
          />
        </TotalCountLabel>
        <span data-test="total-count">{localize(total)}</span>
      </StyledTotalCountBox>
    </TotalCountContainer>
  );
};
